import TimelyProvider from './timelyprovider.svg'
import TimelyProviderWhite from './timelyprovider_white.svg'
import TimelyProviderWhiteBlue from './timelyprovider_white_blue.svg'

const Variants = {
  normal: TimelyProvider,
  white: TimelyProviderWhite,
  whiteblue: TimelyProviderWhiteBlue,
} as const

type LogoProps = {
  className?: string
  variant?: keyof typeof Variants
}

const Logo = ({ className, variant = 'normal' }: LogoProps) => (
  <img alt="TimelyProvider Logo" src={Variants[variant]} className={className} />
)

export default Logo
